/**
 * Shared brand color palette used across the web app.
 */
export const brandColors = {
  gray: ['#F0F0F0', '#E8E8E8', '#CFCFCF', '#ABABAB', '#949494', '#808080', '#666666', '#4D4D4D', '#333333', '#191919'],
  blue: ['#F5F8FF', '#DBE4FF', '#BAC8FF', '#91A7FF', '#748FFC', '#5C7CFA', '#4C6EF5', '#4263EB', '#3B5BDB', '#364FC7'],
  red: ['#FFFAFA', '#FEECED', '#FCDEE0', '#F58E94', '#F16068', '#EE3F49', '#F22128', '#CA0C12', '#AE0A10', '#7D070B'],
  green: ['#EFFAEF', '#DBF5DB', '#C8EFC8', '#B0E8B0', '#A4E5A4', '#90DF90', '#68D468', '#40C940', '#2FA72F', '#1E6B1E'],
  white: ['#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF'],
} as const;

/**
 * Shared typography definitions expressed in raw pixel values.
 */
export const brandTypography = {
  fontFamily: 'Roboto, sans-serif',
  h1Medium: {
    fontSize: 24,
    fontWeight: 500,
    lineHeight: 32,
  },
  h2Medium: {
    fontSize: 20,
    fontWeight: 500,
    lineHeight: 28,
  },
  h2Regular: {
    fontSize: 20,
    fontWeight: 400,
    lineHeight: 28,
  },
  h3Medium: {
    fontSize: 18,
    fontWeight: 500,
    lineHeight: 28,
  },
  p1Regular: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 24,
  },
  p1Medium: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: 24,
  },
  p2Regular: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 24,
  },
  p2Medium: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 24,
  },
  p3Regular: {
    fontSize: 13,
    fontWeight: 400,
    lineHeight: 24,
  },
  p3Medium: {
    fontSize: 13,
    fontWeight: 500,
    lineHeight: 24,
  },
  p4Regular: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 16,
  },
  p4Medium: {
    fontSize: 12,
    fontWeight: 500,
    lineHeight: 16,
  },
} as const;

/**
 * Shared layout tokens reused by standalone branded pages.
 */
export const brandLayout = {
  simplePageBackground: brandColors.gray[1],
  cardBackground: '#FFFFFF',
  cardRadius: 4,
  cardWidth: 384,
  cardPadding: 24,
} as const;
